// extracted by mini-css-extract-plugin
module.exports = {"resultsPanel":"styles-module__resultsPanel___2GLU_","resultsInnerPanel":"styles-module__resultsInnerPanel___nCh_K","pdf":"styles-module__pdf___1Zeif"};